import { Chart } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import { Chart as ChartModel } from "../../../utils/models";
import { getChartLabelFromContext } from "../../../utils/utilities";

import withChart from "../../hoc/withChart";

ChartJS.register(...registerables);

const Pie = (props: ChartModel): JSX.Element => {
  return (
    <Chart
      ref={props.chartRef}
      type="pie"
      data={props.chartData}
      options={options}
    />
  );
};

const options: any = {
  plugins: {
    tooltip: {
      callbacks: {
        label: getChartLabelFromContext,
      },
    },
    legend: {
      display: true,
      position: "right",
    },
  },
};

export default withChart(Pie);
